import {Grid, Typography} from "@mui/material";
import React, {useEffect, useState} from "react";
import {useFormContext} from "react-hook-form";
import {useTranslation} from "react-i18next";
import {FormReportModel} from "../../../api/types/report";
import {FormAutocomplete, FormDatePicker} from "../../../common/form-fields";
import {useReportsRepository} from "../../../api/repositories/ReportRepository";

const CompetitorsBenchmarkForm = ({readOnly}: { readOnly: boolean }) => {
    // Use Translation
    const {t} = useTranslation(["translation", "pricing"]);

    //USE FORM CONTEXT
    const {register, setValue} = useFormContext<FormReportModel>();

    //USE STATE
    const [location, setLocation] = useState<string[]>([]);
    const [lor, setLor] = useState<string[]>([]);

    //USE HOOK CUSTOM
    const {getOffices} = useReportsRepository();

    const handleLocations = async () => {
        const locations: string[] = await getOffices();
        setLocation(locations);
    };

    useEffect(() => {
        handleLocations();

        const lorArray = Array.from(Array(365).keys());
        const lor = [];
        for (let i = 0; i < lorArray.length; i++) {
            lor.push((lorArray[i] + 1).toString());
        }
        setLor(lor);
    }, []);

    return (
        <Grid container columnSpacing={2}>
            <Typography variant="h6" width={"100%"} pl={2} mt={4}>
                {t("pricing:report.labels.searchParameters")}
            </Typography>
            {/* PICK UP FROM */}
            <Grid item xs={12} md={3}>
                <FormDatePicker
                    {...register("competitorsBenchmark.from")}
                    label={`${t("pricing:report.form.from")}*`}
                />
            </Grid>
            {/* LOCATION FROM */}
            <Grid item xs={12} md={3}>
                <FormAutocomplete
                    {...register("competitorsBenchmark.locationPickUp")}
                    label={`${t("pricing:report.form.locationPickUp")}*`}
                    options={location}
                    isOptionEqualToValue={(option: string, value: string) =>
                        option === value
                    }
                    handleChange={(value: string) => {
                        setValue("competitorsBenchmark.locationPickUp", value);
                        setValue("competitorsBenchmark.locationDropOff", value);
                    }}
                />
            </Grid>
            {/* LOCATION TO */}
            <Grid item xs={12} md={3}>
                <FormAutocomplete
                    {...register("competitorsBenchmark.locationDropOff")}
                    label={`${t("pricing:report.form.locationDropOff")}*`}
                    options={location}
                    isOptionEqualToValue={(option: string, value: string) =>
                        option === value
                    }
                />
            </Grid>
            {/* LENGTH OF RENTAL */}
            <Grid item xs={12} md={3}>
                <FormAutocomplete
                    {...register("competitorsBenchmark.rentalPeriod")}
                    label={`${t("pricing:report.form.rentalPeriod")}*`}
                    multiple={true}
                    options={lor}
                    isOptionEqualToValue={(option: string, value: string) =>
                        option === value
                    }
                />
            </Grid>
            {/* SITE */}
            <Grid item xs={12} md={3}>
                <FormAutocomplete
                    {...register("competitorsBenchmark.site")}
                    label={`${t("pricing:report.form.site")}*`}
                    options={["autoeurope.it", "rentalcars.it"]}
                    isOptionEqualToValue={(option: string, value: string) =>
                        option === value
                    }
                />
            </Grid>
        </Grid>
    );
};

export default CompetitorsBenchmarkForm;
